<script lang="ts" setup>
  import type { Dictionary, CountriesDictionary } from '@othercommerce/domain';

  interface Props {
    countries: CountriesDictionary,
    regions: Dictionary
  }

  defineProps<Props>();
</script>

<template>
  <SfFormSelect :label="$t('SHOP.COMMON.LABEL.COUNTRY')" :options="countries" name="countryCode" required />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.FIRSTNAME')" name="firstName" required />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.LASTNAME')" name="lastName" required />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.EMAIL')" autocomplete="username" name="email" required />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.PHONE')" name="phone" />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.PASSWORD')" autocomplete="new-password" name="password" required type="password" />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.CONFIRM_PASSWORD')" autocomplete="new-password" name="password_confirmation" required type="password" />
  <SfAddressForm :regions billable external-country="countryCode" external-type="type" typed />
</template>